import { useState } from 'react';
import { api } from '../api';

export function Login({ onLogin, error }: { onLogin: (b: { tenant: string; agent_id: string; password: string; campaign_id: string }) => Promise<void>; error: string | null }) {
  // No baked-in tenant (AE-10887): remember the last one this browser logged in with.
  const [tenant, setTenant] = useState(() => localStorage.getItem('last_tenant') ?? '');
  const [agentId, setAgentId] = useState('');
  const [password, setPassword] = useState('');
  const [campaignId, setCampaignId] = useState('');
  const [campaigns, setCampaigns] = useState<Array<{ campaign_id: string; name: string }>>([]);
  const [busy, setBusy] = useState(false);
  // The campaign list needs the credentials (AE-10883), so it loads once they are typed. If it
  // cannot (agent not in the roster yet, or a typo), the campaign is entered as text instead.
  const loadCampaigns = () => {
    if (!tenant || !agentId || !password) return;
    api.loginCampaigns({ tenant, agent_id: agentId, password })
      .then((r) => { setCampaigns(r.campaigns); if (r.campaigns.length === 1) setCampaignId(r.campaigns[0]!.campaign_id); })
      .catch(() => setCampaigns([]));
  };
  return (
    <div className="login panel">
      <h2>Agent Login</h2>
      <form onSubmit={async (e) => { e.preventDefault(); setBusy(true); try { await onLogin({ tenant, agent_id: agentId, password, campaign_id: campaignId }); localStorage.setItem('last_tenant', tenant); } finally { setBusy(false); } }}>
        <div className="field"><label>Tenant</label><input value={tenant} onChange={(e) => setTenant(e.target.value)} autoComplete="organization" /></div>
        <div className="field"><label>Agent ID</label><input id="agent-login" value={agentId} onChange={(e) => setAgentId(e.target.value)} autoFocus autoComplete="username" /></div>
        <div className="field"><label>Password</label><input id="agent-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} onBlur={loadCampaigns} autoComplete="current-password" /></div>
        <div className="field"><label>Campaign</label>
          {campaigns.length > 0 ? (
            <select id="select-campaign" value={campaignId} onChange={(e) => setCampaignId(e.target.value)}>
              <option value="">Select a campaign…</option>
              {campaigns.map((c) => <option key={c.campaign_id} value={c.campaign_id}>{c.name}</option>)}
            </select>
          ) : (
            <input id="select-campaign" value={campaignId} onChange={(e) => setCampaignId(e.target.value)} placeholder="Campaign ID" />
          )}
        </div>
        {error && <div className="error">{error}</div>}
        <button className="primary" type="submit" disabled={busy || !agentId || !password || !campaignId} style={{ width: '100%', marginTop: 8 }}>{busy ? 'Logging in…' : 'Log In'}</button>
      </form>
    </div>
  );
}
